<template>
	<transition 
			appear
			:appear-active-class="$_training_stylePageAnimation()">
		<template v-if="initialized_">
			<v-container 
					class="customVContainer fluid"
					:style="$_training_stylePageContainerStyle()"
					fluid>
				<!-- open course -->
				<template v-if="$_training_routeName == 'trainingCourse'">
					<training-module-sheet-layout
						:contents="$_training_contents()"
						:inits="$_training_inits()" />
				</template>
				<!-- open module -->
				<template v-else-if="$_training_routeName == 'trainingModule'">
					<training-section-tab-layout
						:contents="$_training_contents()"
						:inits="$_training_inits()" />
				</template>
				<!-- Page Title -->
				<template v-else>
					<template v-if="$_training_infoShowPageTitle">
						<page-title-layout
								:inits="$_training_inits()" />
					</template>
					<template v-if="!$_training_infoHidePageContents">
						<training-course-sheet-layout
								:contents="$_training_contents()"
								:inits="$_training_inits()" />
					</template>
				</template>
			</v-container>
		</template>
		<template v-else>
			<v-row	class="customVRow">
				<v-col cols="12" class="center">
					<progress-circular />
				</v-col>
			</v-row>
		</template>
	</transition>
</template>

<script>
	export default {
		name: 'Training',
		data() {
			return {
				pageName_: 'training',
				pageType_: 'training',

				initialized_: false
			}
		},
		computed: {
			// route
			$_training_routeName() {
				const self_ = this;
				const route_ = self_.$route
				return route_.name
			},
			// params
			$_training_params() {
				const self_ = this;
				const route_ = self_.$route
				return route_.params
			},
			$_training_paramsCourseCode() {
				const self_ = this;
				const params_ = self_.$_training_params;
				if(self_.isFalse(params_)) { return null }
				return params_.courseCode
			},
			$_training_paramsModuleCode() {
				const self_ = this;
				const params_ = self_.$_training_params;
				if(self_.isFalse(params_)) { return null }
				return params_.moduleCode
			},
			// current user
			$_training_currentUser() {
				const self_ = this;
				return self_.getCurrentUser()
			},
			// state
			$_training_stateAppIsMobileScreen() {
				const self_ = this;
				return self_.getAppState('isMobileScreen')
			},
			$_training_statePageIsInitialized() {
				const self_ = this;
				const initialized_ = self_.getPageState('isInitialized')
				return initialized_[self_.pageName_]
			},
			$_training_stateTrainings() {
				const self_ = this;
				const courseCode_ = self_.$_training_paramsCourseCode;
				if(self_.isFalse(courseCode_)) { return }
				return self_.getTrainingsState(courseCode_)
			},
			$_training_stateUserTraining() {
				const self_ = this;
				return self_.getUserState('training')
			},
			// contents / inits
			$_training_contents() {
				const self_ = this;
				return () => {
					const contents_ = self_.getPageContents(self_.pageName_)
					return self_.getContentsSubset(contents_, 'isDummy', false)
				}
			},
			$_training_inits() {
				const self_ = this;
				return () => {
					return self_.getPageInits(self_.pageName_)
				}
			},
			// info
			$_training_infoContact() {
				const self_ = this;
				return self_.getInitsInfoVal(self_.$_training_inits(), 'contact')
			},
			$_training_infoShowPageTitle() {
				const self_ = this;
				return self_.getInitsInfoVal(self_.$_training_inits(), 'showPageTitle')
			},
			$_training_infoHidePageContents() {
				const self_ = this;
				return self_.getInitsInfoVal(self_.$_training_inits(), 'hidePageContents')
			},
			// style
			$_training_stylePage() {
				const self_ = this;
				return () => {
					if(self_.isEmpty(self_.$_training_inits())) { return null }
					return self_.getInitsStyleVal(self_.$_training_inits(), 'page')
				}
			},
			$_training_stylePageAnimation() {
				const self_ = this;
				return () => {
					const page_ = self_.$_training_stylePage()
					if(self_.isFalse(page_)) { return null }
					return self_.getStylesVal(page_.animation)
				}
			},
			$_training_stylePageContainer() {
				const self_ = this;
				if(self_.isEmpty(self_.$_training_inits())) { return null }
				return self_.getInitsStyleVal(self_.$_training_inits(), 'pageContainer')
			},
			$_training_stylePageContainerStyle() {
				const self_ = this;
				return () => {
					const page_ = self_.$_training_stylePageContainer;
					if(self_.isFalse(page_)) { return null }
					return self_.getStylesVal(page_.style)
				}
			}
		},
		watch: {
			$route() { 
				const self_ = this;
				if(self_.$_training_routeName == 'training') { self_.$_training_updateRoute() }
			}
		},
		created() {
			const self_ = this;
			// life cycle
			self_.createdPage(self_.pageName_)

			self_.$_training_setPageState()

			if(self_.$_training_statePageIsInitialized) { 
				self_.initialized_ = true;
			} else {
				self_.$_training_initialize()
			}
		},
		beforeMount() {
			const self_ = this;
			self_.beforeMountPage(self_.pageName_)
			// update route
			if(self_.$_training_routeName == 'training') { self_.$_training_updateRoute() }
		},
		beforeDestroy() {
			const self_ = this;
			self_.beforeDestroyPage(self_.pageName_)
		},
		methods: {
			$_training_setPageState() {
				const self_ = this;

				self_.setPageState('name', self_.pageName_)
				self_.setPageState('type', self_.pageType_)
			},
			$_training_initialize() {
				const self_ = this;

				Promise.resolve().then(() => {
					return self_.initializePage(self_.pageName_, self_.pageType_)
				}).then(() => {
					return self_.initializeTrainings()
				}).then(() => {
					self_.initialized_ = true;
				}).catch(error => {
/* error */			self_.logError('Error', '$_training_initialize()', error)
				})
			},
			$_training_updateRoute() {
				const self_ = this;
				const router_ = self_.$router;

				const courseCode_ = self_.$_training_paramsCourseCode;
				const moduleCode_ = self_.$_training_paramsModuleCode;

				if(self_.isFalse(courseCode_)) { return }

				self_.initialized_ = false;

				Promise.resolve().then(() => {
					// training module
					if(courseCode_ && moduleCode_) {
						router_.replace({
							name: 'trainingModule',
							params: {
								courseCode: courseCode_,
								moduleCode: moduleCode_
							}
						})
					}
					// training course
					else {
						router_.replace({
							name: 'trainingCourse',
							params: {
								courseCode: courseCode_
							}
						})
					}

					self_.initialized_ = true;
				})
			}
		}
	}
</script>

<style scoped>
</style>